import React from 'react';
import {ResizableBox} from 'react-resizable';
import classnames from 'classnames';
import ScanImg from './ScanImg.jsx';
import Diff from './Diff.jsx';
import Error from './Error.jsx';
import Symbols from './Symbols.jsx';
import Snippets from './Snippets.jsx';

class Card extends React.Component{
    constructor(props){
        super(props);

        this.gate = props.gate;
        this.canWriteMaster = props.canWriteMaster;
        this.textArea = React.createRef();
        this.textAreaFocused = false;

        this.state = {
            code: props.code,
            corpus: props.corpus,
            header: props.header,
            isNew: props.isNew,
            originalBody: '',
            body: '',
            commit_message: '',
            linkedCard: null,
            diffOpen: false,
            previewMode: 'preview',        
            symbolsOpen: false,
            snippetsOpen: false,     
            commitOpen: false,
            commiting: false,
            commitProgress: 0,
            loaded: false            
        }

        if(props.conf.corpuses[props.corpus].imagesRepo){
            this.state.previewMode = 'scan';
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleCommitMessageChange = this.handleCommitMessageChange.bind(this);
        this.handlePreviewClick = this.handlePreviewClick.bind(this);
        this.toHTML = this.toHTML.bind(this);
        this.commit = this.commit.bind(this);
        this.startCommit = this.startCommit.bind(this);
        this.insertItalic = this.insertItalic.bind(this);
        this.insertLink = this.insertLink.bind(this);
        this.insertCharacter = this.insertCharacter.bind(this);
        this.insertSnippet = this.insertSnippet.bind(this);
        this.toggleSymbols = this.toggleSymbols.bind(this);
        this.toggleSnippets = this.toggleSnippets.bind(this);
        this.setBody = this.setBody.bind(this);
        this.togglePreview = this.togglePreview.bind(this);
    }

    componentDidMount(){
        var self = this;
        if(this.state.isNew){
            var body = this.state.header+"\n";            
            this.setState({
                originalBody: body,
                body: body,
                loaded: true
            });
            return;
        }
        this.gate.getCardVersion(
            this.state.corpus, 
            this.state.code, 
            null,
            (body)=>{
                this.setState({
                    originalBody: body,
                    body: body, 
                    loaded: true
                });
            },
            (error) => {
                self.props.raiseError(
                    <Error 
                        text={'Не удалось получить карточку из Github. Ошибка '+error}
                        onDismiss={self.props.dismissError}
                    />
                );
            }
        );
    }

    toggleSymbols(){
        this.setState({symbolsOpen: !this.state.symbolsOpen})
    }

    toggleSnippets(){
        this.setState({snippetsOpen: !this.state.snippetsOpen})
    }

    togglePreview(){
        var mode = this.state.previewMode == 'preview' ? 'scan' : 'preview';
        this.setState({previewMode: mode});
    }

    handleChange(e){        
        this.setBody(e.currentTarget.value)
    }

    handleCommitMessageChange(e){
        this.setState({
            commit_message: e.currentTarget.value
        });
    }

    handlePreviewClick(e){
        e.stopPropagation(); ;
        e.preventDefault();
        var target = e.target;
        if(target.tagName.toLowerCase() == 'a'){
            this.setState({linkedCard:{body:''}})
            this.gate.getCardVersion(
                this.state.corpus, 
                target.getAttribute('href').replace('#',''), 
                'master',
                (body)=>{
                    this.setState({
                        linkedCard: {
                            body: body
                        }
                    });
                },
                (error) => {
                    this.props.raiseError(
                        <Error 
                            text={'Не удалось получить карточку из Github. Ошибка '+error}
                            onDismiss={() => {
                                this.setState({linkedCard: null});
                                this.props.dismissError();
                            }}
                        />
                    );
                }
            );
        }
    }

    setBody(body, callback=()=>{}){
        this.setState({
            body: body
        }, callback);
        this.props.updateCardChangeStatus(this.state.corpus, this.state.code, body != this.state.originalBody);
    }

    modifyBody(left, right, mode=true){
        if(!this.textAreaFocused && mode) return;

        var textComponent = this.textArea.current;
        var textComponentScrollTop = textComponent.scrollTop;

        if (textComponent.selectionStart !== undefined){
            var startPos = textComponent.selectionStart;
            var endPos = textComponent.selectionEnd;
            if(startPos == 0 && endPos == 0){
                newBody = this.state.body+left+right;
            }
            else{
                var newBody = this.state.body.substring(0, startPos) + 
                left + this.state.body.substring(startPos, endPos) + right +
                this.state.body.substring(endPos);
            }
        }
        else{
            newBody = this.state.body + left + right;
        }
                
        this.setBody(
            newBody,
            () => window.setTimeout(() => {
                textComponent.focus();
                textComponent.setSelectionRange(startPos+left.length,endPos+left.length);
                textComponent.scrollTop = textComponentScrollTop;
            },100)
        );
        
    }

    insertItalic(){
        this.modifyBody('<i>','</i>');
    }

    insertLink(){
        this.modifyBody('<a href="#...">','</a>');
    }

    insertCharacter(c){
        this.setState(
            {symbolsOpen: false},
            ()=>{
                this.modifyBody(c,'', false);
            }
        );        
    }

    insertSnippet(s){
        this.setState(
            {snippetsOpen: false},
            ()=>{
                this.modifyBody(s,'', false);
            }
        );        
    }

    toHTML(t){
        t = '<p>'+t.replace(/\n/g,"</p><p>")+'</p>';
        t = t.replace(/<p><\/p>/g,'<p>&nbsp;<\/p>');
        // Старый синтаксис ссылок БЯРС
        t = t.replace(/&lt;&lt;([^|]+)\|([^&]+)&gt;&gt;/g, '<a href="$1">$2</a>');
        return t;
    }

    startCommit(){
        var errors = [];
        if(this.props.conf.corpuses[this.state.corpus].articleValidator){
            errors = this.props.conf.corpuses[this.state.corpus].articleValidator(this.state.body);
        }

        if(errors.length){
            this.props.raiseError(
                <Error
                    text={errors.join('<br/>')}
                    onDismiss={this.props.dismissError}
                />
            );
            return;
        }

        this.setState({commitOpen: true});
    }

    commit(){
        var self = this;

        if(this.state.isNew){
            var commit = {
                content: self.state.body,                
                commit_message: this.state.commit_message
            }
            self.setState({commiting: true});
            
            self.gate.getNextCardNumber(
                self.state.corpus,
                (cardNumber)=>{
                    commit.card_code = cardNumber;
                    commit.content = self.state.body.replace(/〔[^〕]+〕/, '〔'+cardNumber+'〕');
                    self.setState({commitProgress: 25});
                    self.gate.commit(
                        self.state.corpus,
                        true,
                        self.canWriteMaster,
                        commit,
                        (progress)=>{
                            self.setState({commitProgress: progress});
                        },
                        () => {        
                            self.setState(
                                {commitProgress: 100},
                                () => {
                                    window.setTimeout(
                                        ()=>{
                                            var newHeader = commit.content.split("\n")[0];
                                            var oldCode = self.state.code;
                                            
                                            self.setState({
                                                commit_message: '',
                                                commitOpen: false,
                                                commiting: false,
                                                commitProgress: 0,
                                                code: cardNumber,
                                                isNew: false,
                                                originalBody: commit.content,
                                                body: commit.content,
                                                header: newHeader
                                            },
                                            ()=>{
                                                self.props.acceptCard(
                                                    self.state.corpus,
                                                    oldCode,
                                                    cardNumber,
                                                    newHeader
                                                )  
                                            })
                                        },
                                        500
                                    );
                                }
                            );                           
                        },
                        (error)=>{
                            self.props.raiseError(
                                <Error 
                                    text={'Не удалось добавить новую карточку. Ошибка: '+error}
                                    onDismiss={() => {
                                        self.setState({commiting: false}, self.props.dismissError);
                                    }}
                                />
                            );
                        }
                    )
                },
                (error) => {
                    self.props.raiseError(
                        <Error 
                            text={'Не удалось присвоить карточке номер. Ошибка: '+error}
                            onDismiss={() => {
                                self.setState({commiting: false}, self.props.dismissError);
                            }}
                        />
                    );
                }
            );
        }
        else{
            var commit = {
                content: self.state.body,
                card_code: self.state.code,
                commit_message: self.state.commit_message
            }
            self.setState({commiting: true});
            self.gate.commit(
                self.state.corpus, 
                false,
                self.canWriteMaster,
                commit,
                (progress)=>{
                    self.setState({commitProgress: progress});
                },
                ()=>{
                    self.setState(
                        {commitProgress: 100},
                        () => {
                            window.setTimeout(
                            () => {
                                self.setState({
                                    commit_message: '',
                                    commitOpen: false,
                                    commiting: false,
                                    commitProgress: 0,
                                    originalBody: commit.content
                                },
                                ()=>{
                                    self.props.acceptCard(
                                        self.state.corpus,
                                        self.state.code,
                                        self.state.code,
                                        commit.content.split("\n")[0]
                                    )   
                                })
                            },
                            500)
                        }
                    );                
                },
                (error)=>{
                    self.props.raiseError(
                        <Error 
                            text={'Не удалось сохранить карточку. Ошибка: '+error}
                            onDismiss={() => {
                                self.setState({commiting: false}, self.props.dismissError);
                            }}
                        />
                    );
                }
            );
        }
    }

    render(){
        var st = this.state;
        if(!st.loaded) return <div className="loading"><h2><i className="fas fa-circle-notch fa-spin"></i></h2></div>;;

        return (
            <React.Fragment>
                <div className="editor-tools p-2 d-flex">
                    <div className="d-flex border-right">
                        <button 
                            className="btn btn-outline-secondary btn-icon btn-sm mr-2"
                            disabled={st.originalBody == st.body} 
                            onClick={this.startCommit}
                            title="сохранить"
                        >
                            <i className="fas fa-save"></i>
                        </button>
                        <button 
                            className="btn btn-outline-secondary btn-icon btn-sm mr-2" 
                            disabled={st.isNew} 
                            onClick={()=>this.setState({diffOpen:true})}
                            title="история изменений"
                        >
                            <i className="fas fa-history"></i>
                        </button>
                    </div>
                    <div className="d-flex border-left">
                        <button
                            className="btn btn-outline-secondary btn-icon btn-sm ml-2" 
                            onMouseDown={this.insertItalic}
                        >
                            <i className="fas fa-italic"></i>
                        </button>
                        <button
                            className="btn btn-outline-secondary btn-icon btn-sm ml-2" 
                            onMouseDown={this.insertLink}
                        >
                            <i className="fas fa-link"></i>
                        </button>
                        <div className="position-relative">
                            <button
                                className={classnames({
                                    'btn': true,
                                    'btn-outline-secondary': true,
                                    'btn-icon': true,
                                    'btn-sm': true,
                                    'ml-2': true,
                                    'active': this.state.snippetsOpen
                                })} 
                                onClick={this.toggleSnippets}
                            >
                                <i className="fas fa-bookmark"></i>
                            </button>
                            {this.state.snippetsOpen && 
                                <Snippets 
                                    onClick={this.insertSnippet}
                                    onClose={this.toggleSnippets}
                                />
                            }                            
                        </div>
                        <div className="position-relative">
                            <button
                                className={classnames({
                                    'btn': true,
                                    'btn-outline-secondary': true,
                                    'btn-icon': true,
                                    'btn-sm': true,
                                    'ml-2': true,
                                    'active': this.state.symbolsOpen
                                })} 
                                onClick={this.toggleSymbols}
                            >
                                Ω
                            </button>
                            {this.state.symbolsOpen && 
                                <Symbols 
                                    onClick={this.insertCharacter}
                                    onClose={this.toggleSymbols}
                                />
                            }                            
                        </div>
                    </div>
                </div>
                
                <ResizableBox className="editor p-2" axis="y" height={250} resizeHandles={['s']}>
                    <textarea 
                        className="form-control" 
                        ref={this.textArea}
                        onChange={this.handleChange} 
                        onFocus={() => {this.textAreaFocused = true}}
                        onBlur={() => {this.textAreaFocused = false}}
                        value={st.body} 
                    />
                </ResizableBox>
                
                {this.props.conf.corpuses[this.state.corpus].imagesRepo && (
                    <ul className="secondary-tabs nav nav-tabs mt-1">
                        <li className="nav-item">
                            <a 
                                className={classnames({'nav-link':true, 'active':this.state.previewMode == 'scan'})}
                                onClick={this.togglePreview}
                            >
                                Скан
                            </a>
                        </li> 
                        <li className="nav-item">
                            <a 
                                className={classnames({'nav-link':true, 'active':this.state.previewMode == 'preview'})}
                                onClick={this.togglePreview}
                            >
                                Предпросмотр
                            </a>
                        </li>                        
                    </ul>
                )}
                
                <div 
                    className={classnames({
                        "d-none": this.state.previewMode != 'preview', 
                        "preview":true, "flex-grow-1":true, "m-2":true, "pr-2":true})}
                    onClick={this.handlePreviewClick}
                    dangerouslySetInnerHTML={{ __html: this.toHTML(st.body) }} 
                />
                {this.state.previewMode == 'scan' && (
                    <div 
                        className={classnames({                             
                            "scan":true, "flex-grow-1":true, "m-2":true, "pr-2":true})}
                    >
                        <ScanImg 
                            code={this.state.code} 
                            corpus={this.state.corpus} 
                            gate={this.gate}
                        />
                    </div>
                )}                

                {this.state.diffOpen && (                    
                    <Diff 
                        code={this.state.code} 
                        corpus={this.state.corpus} 
                        body={this.state.body} 
                        gate={this.gate}
                        close={()=>this.setState({diffOpen:false})}
                        raiseError={this.props.raiseError}
                        dismissError={this.props.dismissError}
                    />
                )}
                
                {this.state.commitOpen && (
                    <div className="overlay">
                        <div className="window commit-form">
                            <label>Описание изменений:</label>
                            <label className="small">
                                Кратко опишите суть внесенных вами изменения. 
                                Если вы хотите сослаться на issue, то это можно сделать так: #номер.
                            </label>
                            
                            <input
                                type="text" 
                                className="commit-message form-control" 
                                onChange={this.handleCommitMessageChange} 
                                value={this.state.commit_message} 
                            />

                            {!this.canWriteMaster && (
                                <div className='small'>
                                    Вносимые вами изменения будут записаны в отдельную ветку репозитория.
                                    После этого один из редакторов словаря одобрит или отклонит их.
                                </div>
                            )}

                            <div className="d-flex flex-row justify-content-end">
                                <button type="button" className="btn btn-outline-secondary" onClick={()=>{this.setState({commitOpen:false})}}>Отменить</button>
                                <button type="button" className="btn btn-primary ml-2" onClick={this.commit} disabled={!this.state.commit_message}>                                   
                                    Сохранить
                                </button>
                            </div>
                            <div className="close-btn" onClick={()=>{this.setState({commitOpen:false})}}>
                                <span className="fa fa-times"></span>
                            </div>

                            {this.state.commiting && (
                                <div className="fog">
                                    <label>Идёт сохранение новой версии...</label>
                                    <div className="progress">
                                        <div className="progress-bar progress-bar-striped progress-bar-animated" style={{width: this.state.commitProgress+'%'}}></div>
                                    </div>
                                </div>
                            )}                            
                        </div>
                    </div>
                )}

                {this.state.linkedCard && (
                    <div className="overlay">
                        <div className="window linked-card">
                            {this.state.linkedCard.body == '' ? (
                                <div className="loading"><h3><i className="fas fa-circle-notch fa-spin"></i></h3></div>
                            ) : (
                                <React.Fragment>
                                    <div 
                                        className="preview"
                                        onClick={this.handlePreviewClick}
                                        dangerouslySetInnerHTML={{ __html: this.toHTML(this.state.linkedCard.body)}}
                                    />
                                    <div className="close-btn" onClick={() => {this.setState({linkedCard: null})}}>
                                        <span className="fa fa-times"></span>
                                    </div>
                                </React.Fragment>
                            )}                            
                        </div>
                    </div>
                )}
            </React.Fragment>
        )
    }
}

export default Card;